<template>
  <div class="main-header side-header sticky">
    <div class="container-fluid">
      <div class="main-header-right">
        <a class="main-header-menu-icon" href="#" id="mainSidebarToggle"
          ><span></span
        ></a>
      </div>
      <div class="main-header-center">
        <div class="responsive-logo">
          <a href="index.html"
            ><img
              src="/assets/img/brand/logo.png"
              class="mobile-logo"
              alt="لوگو"
          /></a>
          <a href="index.html"
            ><img
              src="/assets/img/brand/logo-light.png"
              class="mobile-logo-dark"
              alt="لوگو"
          /></a>
        </div>
      </div>
      <div class="main-header-right">
        <img
          class="izb-logo"
          src="/assets/img/logo-shora.png"
          v-if="
            $store.state.userData.isOrganization &&
              !$store.state.userData.hasWallet &&
              $store.state.userData.organizationName == 'شورای نگهبان'
          "
        />
        <img
          class="izb-logo"
          src="/assets/img/logo.png"
          v-if="$store.state.role == 'tourismorg'"
        />
        <div
          v-if="balance"
          style="display: flex; height: 100%; align-items: center;margin-left: 1rem;"
        >
          <button
            class="btn "
            style="display: flex; align-items: center; justify-content: center;"
            @click="getBalance"
            :class="{ loading: balanceLoading }"
          >
            <i class="ti-reload"></i>
          </button>
          <p style="margin: 0;">موجودی کیف پول سازمان : {{ balance }} ریال</p>
        </div>
        <div
          class="dropdown main-header-notification"
          v-if="$store.state.role == 'organization'"
        >
          <a class="nav-link icon" href="#">
            <i class="fe fe-bell header-icons"></i>
            <span class="badge badge-danger nav-link-badge">{{
              publicNotifications.length +
                organizationNotifications.length +
                personnelNotifications.length
            }}</span>
          </a>
          <div class="dropdown-menu">
            <div class="header-navheading">
              <p class="main-notification-text mt-2">
                شما
                {{
                  publicNotifications.length +
                    organizationNotifications.length +
                    personnelNotifications.length
                }}
                اعلان دارید
              </p>
            </div>
            <div class="main-notification-list">
              <span class="media" v-if="publicNotifications.length">
                <div class="media-body mt-1">
                  <p>
                    <b class="badge badge-danger ml-1">{{
                      publicNotifications.length
                    }}</b>
                    مناسبت ملی / مذهبی
                  </p>
                  <button
                    class="btn btn-info notification-calendar-details"
                    data-toggle="modal"
                    data-target="#national-religious"
                  >
                    مشاهده
                  </button>
                </div>
              </span>
              <span class="media" v-if="organizationNotifications.length">
                <div class="media-body mt-1">
                  <p>
                    <b class="badge badge-danger ml-1">{{
                      organizationNotifications.length
                    }}</b>
                    مناسبت سازمانی
                  </p>
                  <button
                    class="btn btn-info notification-calendar-details"
                    data-toggle="modal"
                    data-target="#organization"
                  >
                    مشاهده
                  </button>
                </div>
              </span>
              <span class="media" v-if="personnelNotifications.length">
                <div class="media-body mt-1">
                  <p>
                    <b class="badge badge-danger ml-1">{{
                      personnelNotifications.length
                    }}</b>
                    مناسبت پرسنل
                  </p>
                  <button
                    class="btn btn-info notification-calendar-details"
                    data-toggle="modal"
                    data-target="#birthdates"
                  >
                    مشاهده
                  </button>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="dropdown main-profile-menu">
          <a class="d-flex" href="#">
            <span class="main-img-user"
              ><img alt="آواتار" src="/assets/img/users/default.jpg"
            /></span>
          </a>
          <div class="dropdown-menu">
            <div class="header-navheading">
              <h6 class="main-notification-title">
                {{
                  $store.state.userData.organizationName ||
                    $store.state.userData.name +
                      " " +
                      $store.state.userData.lastName
                }}
              </h6>
            </div>
            <router-link
              class="dropdown-item border-top"
              :to="{ name: 'changePassword' }"
              ><i class="fe fe-user"></i> تغییر رمز عبور
            </router-link>
            <a class="dropdown-item" href="#" v-on:click="logout">
              <i class="fe fe-power"></i> خروج از سیستم
            </a>
          </div>
        </div>
        <button
          class="navbar-toggler navresponsive-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent-4"
          aria-controls="navbarSupportedContent-4"
          aria-expanded="false"
          aria-label="تغییر پیمایش"
        >
          <i class="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  name: "Header",
  data() {
    return {
      publicNotifications: [],
      organizationNotifications: [],
      personnelNotifications: [],
      balance: "",
      balanceLoading: false,
    };
  },

  methods: {
    logout(e) {
      e.preventDefault();

      this.$api
        .get("User/Logout")
        .then(() => {
          // درخواست موفق → خروج عادی
          localStorage.removeItem("agc-token");
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          // اگر درخواست با 401 شکست خورد → توکن حذف و انتقال به لاگین
          if (error.response.status === 401) {
            localStorage.removeItem("agc-token");
            this.$router.push({ name: "login" });
          }
        });
    },
    getData() {
      let today = new Date().getTime();
      let oneDayTime = 60 * 60 * 24 * 1000;
      // let twoDaysAgo = moment(new Date(today - (oneDayTime * 2))).format('jYYYY-jMM-jDD');
      // let twoDaysLater = moment(new Date(today + (oneDayTime * 2))).format('jYYYY-jMM-jDD');
      let sevenDaysAgo = moment(new Date(today - oneDayTime * 7)).format(
        "jYYYY-jMM-jDD"
      );
      let threeDaysLater = moment(new Date(today + oneDayTime * 3)).format(
        "jYYYY-jMM-jDD"
      );
      // let sevenDaysLater = moment(new Date(today + (oneDayTime * 7))).format('jYYYY-jMM-jDD');
      const postedData = {
        eventType: [1, 2, 3],
        formData: sevenDaysAgo,
        toDate: threeDaysLater,
      };
      this.$api.post("Organizations/GetEvents", postedData).then(({ data }) => {
        data.result.result.map((item) => {
          if (item.eventType == 1)
            this.publicNotifications.push({
              title: item.title,
              date:
                item.date.slice(0, 4) +
                "-" +
                item.date.slice(4, 6) +
                "-" +
                item.date.slice(6, 8),
            });
          if (item.eventType == 2)
            this.organizationNotifications.push({
              title: item.title,
              date:
                item.date.slice(0, 4) +
                "-" +
                item.date.slice(4, 6) +
                "-" +
                item.date.slice(6, 8),
            });
          if (item.eventType == 3)
            this.personnelNotifications.push({
              title: item.title,
              date:
                item.date.slice(0, 4) +
                "-" +
                item.date.slice(4, 6) +
                "-" +
                item.date.slice(6, 8),
            });
        });
        this.$store.state.nationalReligious = this.publicNotifications;
        this.$store.state.organization = this.organizationNotifications;
        this.$store.state.birthdates = this.personnelNotifications;
      });
    },
    getBalance() {
      this.balanceLoading = true;
      this.$api
        .get("Organizations/OrganizationChargeWallet/GetBalance", {
          SuppressedError: true,
        })
        .then(({ data }) => {
          if (data.status) {
            this.balance = Number(data.result).toLocaleString("fa-IR");
          } else {
            this.balance = "";
          }
        })
        .catch()
        .finally(() => {
          this.balanceLoading = false;
        });
    },
  },
  created() {
    if (this.$store.state.userData.isOrganization) this.getData();
  },
  mounted() {
    this.getBalance();
  },
};
</script>
